import { StandardModal } from "@design-system/Modal/Modal";
import { useOverlays } from "contexts/OverlayContext";
import { EnrollOrganizationModal } from "./EnrollOrganizationModal";

export const EnrollOrganizationModalOverlay = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("enrollOrganization");

    if (!overlayInfo) {
        return null;
    }

    return (
        <StandardModal
            backdrop="static"
            show={!overlayIsClosing}
            onHide={closeOverlay}
            className={undefined}
        >
            <EnrollOrganizationModal action={overlayInfo.data?.action} />
        </StandardModal>
    );
};
